export const LIST_SIZE = 10

export enum NavTab {
  ACTIVITY = 'activity',
  ADDRESS = 'address',
  COMPANY = 'company',
  CONTACT = 'contact',
  DOCUMENT = 'document',
  EXTERNAL_COMPANY = 'external-company',
  EXTERNAL_PERSON = 'external-person',
  FOLLOW_UPS = 'follow-ups',
  INTERNAL_COMPANY = 'internal-company',
  INTERNAL_PERSON = 'internal-person',
  INVOICE = 'invoice',
  MESSAGE = 'message',
  OPPORTUNITY = 'opportunity',
  ORDER = 'order',
  PERSON = 'person',
  QUOTE = 'quote',
  TICKET = 'ticket',
}
